module.exports = __webpack_public_path__ + "static/media/corporate-services-img6.236fd6ba.jpg";